import React from "react"
import { connect } from "react-redux";

import P24RestaurantLogFilter from "../../../components/p24/P24RestaurantLogFilter"

import { fetchP24RestaurantLogsByFilter } from "../../../actions/p24RestaurantLogActions";
import P24LogTable from "../../../components/p24/P24LogTable";


/**
 * Logi P24 dla wybranej restauracji
 */
class RestaurantP24Logs extends React.Component {

    componentDidMount() {

        //identyfikator wybranej restauracji (z url)
        const restaurantId = this.props.match.params.id;

        //ladowanie danych do tabeli - przy inicjalizacji komponentu
        this.props.fetchP24RestaurantLogsByFilter(restaurantId, this.props.p24RestaurantLogFilter);
    }

    /**
     *  Obsluga zmiany filtra
     */
    onFilterChange = () => {

        //identyfikator wybranej restauracji (z url)
        const restaurantId = this.props.match.params.id;

        //ladowanie danych do tabeli - po aktualizacji filtra
        this.props.fetchP24RestaurantLogsByFilter(restaurantId, this.props.p24RestaurantLogFilter);
    }

    render() {
        return (
            <div>
                <h3>Logi P24</h3>

                <P24RestaurantLogFilter onFilterChange={this.onFilterChange} />

                <br />

                <P24LogTable logs={this.props.p24RestaurantLogList} />

            </div>
        )
    }
}

const mapStateToProps = state => ({
    p24RestaurantLogFilter: state.p24RestaurantLogReducer.p24RestaurantLogFilter,
    p24RestaurantLogList: state.p24RestaurantLogReducer.p24RestaurantLogList,
});


const mapDispatchToProps = ({
    fetchP24RestaurantLogsByFilter: fetchP24RestaurantLogsByFilter
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RestaurantP24Logs);

